import { render } from "./SidebarAdmin.vue?vue&type=template&id=526837cc&scoped=true"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"

import "./SidebarAdmin.vue?vue&type=style&index=0&id=526837cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526837cc"]])

export default __exports__